import { MarkerStop } from "./MarkerStop";
import MarkerClusterGroup from "react-leaflet-markercluster";
import { ToolsContext } from "../../ToolsContext";
import { useContext } from "react";
import { useQueryGtfsResource } from "../../Queries";

export function MarkerStopLayer() {
    const tool = useContext(ToolsContext);
    const { isPending, error, data: GStops } = useQueryGtfsResource('stops');

    let MarkersStops = (<></>);

    if (isPending || error || (Object.entries(GStops).length = 0)) {
        return <></>;
    }

    MarkersStops = Object.entries(GStops).map(([, GStop]) => {
        return (<MarkerStop key={GStop.stop_id + (tool.selection === GStop.stop_id).toString()} GStopId={GStop.stop_id} openPopup={tool.selection == GStop.stop_id} isDraggable={tool.selection === GStop.stop_id} />);
        // React nie chciał rerednerować markera po zmianie kontekstu na przesuwalny, więc wymusiliśmy to zmianą klucza.
        // Rozwiązanie raczej prowizoryczne...
      });
      
    return (<MarkerClusterGroup spiderfyOnMaxZoom={false} disableClusteringAtZoom={17}>{MarkersStops}</MarkerClusterGroup>);
}